import React, { Component } from "react";
import LoginBanner from "../../../Utils/GenericUI/LoginBanner.jsx";
import { Body } from "../../../Utils/StaticData/EnrollStepsStaticData.jsx";
import {
  agentLogin,
  successfulSignUp,
  LogoutToken,
  resetStore,
  setStateParams,
  setLoginStateParams,
  setPageName,
} from "../../../Redux/Actions/webAppActions.js";
import { connect } from "react-redux";
import { sessionExpired } from "../../../Redux/Actions/keyCloakAction";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import KeyCloakLogin from "./KeycloakLogin.js";
import BeneficaryLogin from "./BeneficiaryLogin.jsx";
import { Text } from "react-internationalization";
import { loginText } from "../../translations/dynamic.js";
import {
  ILS_CONSTS,
  NEBRASKA_CONSTS,
  loginContainer,
} from "../../../Utils/StaticData/Constant.js";
class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      passwrd: "",
      vertical: "top",
      horizontal: "center",
      userLogin: "beneficiary", //customer specific default value logic is written in didmount
      everity: "success",
      snackBarMsg:"",
      snackBarOpen:false
    };
  }
  componentDidMount() {
    //metion the customer Ids in the below array if they only have agent login
    if ([NEBRASKA_CONSTS.ID,ILS_CONSTS.ID].some((ids) => this.props.customerId === ids)) {
      this.setState({ ...this.state, userLogin: "agent" });
    }
    const collection1 = document.getElementsByClassName(
      "modal-backdrop fade show"
    );
    while (collection1.length > 0) {
      collection1[0].remove();
    }
    this.props.LogoutToken();
    window.localStorage.setItem("customerid", this.props?.customerId);
    window.localStorage.setItem("customerId", this.props?.customerId);
    window.sessionStorage.setItem("pcpApiKey", this.props?.pcpApiKey);
    window.sessionStorage.setItem("beneficiaryLogin", false);
    window.sessionStorage.setItem("agentLoggedIn", false);
    window.sessionStorage.setItem("guestLogin", false);
    window.sessionStorage.setItem("agentLogin", false);
    window.localStorage.setItem("theme", this.props?.theme);
    window.localStorage.setItem("pcpSubscription", this.props.pcpSubscription);
    window.sessionStorage.setItem("subDomain", this.props.subDomain);
    window.sessionStorage.setItem(
      "supportingServices",
      JSON.stringify(this.props.supportingServices)
    );
    window.sessionStorage.removeItem("keyCloakData");
    window.sessionStorage.removeItem("token");
    window.sessionStorage.setItem("lang",this.props?.lang??"en")
    this.props.resetStore();
    this.props.setLoginStateParams(
      "pcpApiKey",
      window.sessionStorage.getItem("pcpApiKey")
    );
    window.sessionStorage.removeItem("pcpApiKey");
    this.props.setLoginStateParams(
      "theme",
      window.localStorage.getItem("theme")
    );
    this.props.setLoginStateParams(
      "subDomain",
      window.sessionStorage.getItem("subDomain")
    );
    window.sessionStorage.removeItem("subDomain");
    window.localStorage.removeItem("theme");
    this.props.setLoginStateParams(
      "customerId",
      window.localStorage.getItem("customerid")
    );
    this.props.setPageName("login");
    this.props.setLoginStateParams(
      "pcpSubscription",
      window.localStorage.getItem("pcpSubscription")
    );
    this.props.setLoginStateParams(
      "supportingServices",
      JSON.parse(window.sessionStorage.getItem("supportingServices"))
    );
    window.localStorage.removeItem("pcpSubscription");
    this.props.setLoginStateParams("deeplink", false);
    this.props.setStateParams("selectedPlansForCompare", []);
    this.props.setStateParams("guestbeneagentAppNum", null);
    this.props.setStateParams("appNum", null);
    this.props.setStateParams("pendingApplFlag", false);
    this.props.setStateParams("preEnrollInfo", {});
    this.props.setLoginStateParams("beneficiaryLogin", false);
    this.props.setLoginStateParams("guestLogin", false);
    this.props.setLoginStateParams("idleTime", 0);
    this.props.setStateParams("language",window.sessionStorage.getItem("lang"));
    this.props.sessionExpired(window.sessionStorage.getItem("isExpired"));
    window.scroll(0, 0);
    this.props.agentLogin(false);
    
    if(window.localStorage.getItem("agencyAPIFlag")==="true"){
      //currently this if block is unused
      this.setState({
        snackBarOpen: true,
        vertical: "top",
      horizontal: "center",
      severity: "error",
      snackBarMsg:"Unauthorized user access is not allowed!"
      });
      window.localStorage.setItem("agencyAPIFlag",false)
    }else{
    this.setState({
      snackBarOpen: false,
      severity: "sucess"
    });
    }
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
    this.props.successfulSignUp(false);
  };
  handleClickBeneficiary = (event) => {
    event.preventDefault();
    this.setState({
      userLogin: "beneficiary",
    });
  };
  handleClickAgent = (event) => {
    event.preventDefault();
    this.setState({
      userLogin: "agent",
    });
  };

  render() {
    const { vertical, horizontal ,severity, snackBarMsg,snackBarOpen} = this.state;
    return (
      <div id="userLogin" class="login-page">
        <div class="content-area ">
          <LoginBanner header={""} Body={Body} />
          <div class={loginContainer(this.props.customerId)}>
            {/* {this.props.successignUp === true ? ( */}
              <Snackbar
                open={snackBarOpen || this.props.successignUp}
                autoHideDuration={3000}
                onClose={this.handleClose}
                anchorOrigin={{ vertical, horizontal }}
                key={vertical + horizontal}
              >
                <Alert onClose={this.handleClose} severity={severity}>
                {this.props.successignUp?<Text id="user.successSignup" />:snackBarMsg}
                </Alert>
              </Snackbar>
            {/* ) : (
              ""
            )} */}
            <div class="display-flex111 ">
              <ul class="nav nav-tabs nav-justified">
                {[NEBRASKA_CONSTS.ID,ILS_CONSTS.ID].every(
                  (ids) => this.props.customerId !== ids
                ) && (
                  <li class="nav-item margin-right beneficiary-margin-right">
                    <a
                      class={
                        this.state.userLogin === "beneficiary"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      data-toggle="tab"
                      href="#beni_guest"
                      onClick={this.handleClickBeneficiary}
                    >
                      {loginText("beneficiary", this.props.customerId)}
                    </a>
                  </li>
                )}
                {this.props.theme !== "Sharp" && (
                  <li class="nav-item">
                    <a
                      class={
                        this.state.userLogin === "agent"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      data-toggle="tab"
                      onClick={this.handleClickAgent}
                      href="#agent"
                    >
                      {loginText("agent", this.props.customerId)}
                    </a>
                  </li>
                )}
              </ul>
            </div>
            <div class="display-flex111 tab-content tab-content-top-radious-zero login-container">
              <div
                class={
                  this.state.userLogin === "agent"
                    ? "tab-content-login111 tab-pane fade active show"
                    : "tab-content-login111 tab-pane fade"
                }
                id="agent"
              >
                <KeyCloakLogin />
              </div>
              {[NEBRASKA_CONSTS.ID,ILS_CONSTS.ID].every(
                (ids) => this.props.customerId !== ids
              ) && (
                <div
                  class={
                    this.state.userLogin === "beneficiary"
                      ? "tab-content-login111 tab-pane fade active show"
                      : "tab-content-login111 tab-pane fade "
                  }
                  id="beni_guest"
                >
                  <BeneficaryLogin />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    customerId: state.login.customerId,
    pcpApiKey: state.login.pcpApiKey,
    theme: state.login.theme,
    pcpSubscription: state.login.pcpSubscription,
    subDomain: state.login.subDomain,
    supportingServices: state.login.supportingServices,
  };
};
const mapDispatchToProps = {
  agentLogin,
  successfulSignUp,
  LogoutToken,
  setStateParams,
  setLoginStateParams,
  resetStore,
  setPageName,
  sessionExpired,
};
export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);
